import React from "react";
import { ImageUploader } from "@/components/cms/ImageUploader";

interface Props {
  value?: string[];
  onChange: (urls: string[]) => void;
  testid?: string;
}

/** Manages an ordered list of images: add, replace, remove — all optional (0..n). */
export const MultiImageUploader: React.FC<Props> = ({ value, onChange, testid = "multi-image" }) => {
  const images = Array.isArray(value) ? value : [];
  return (
    <div className="flex flex-wrap gap-3" data-testid={testid}>
      {images.map((url, i) => (
        <ImageUploader
          key={`${url}-${i}`}
          testid={`${testid}-item-${i}`}
          value={url}
          onChange={(u) =>
            u ? onChange(images.map((x, xi) => (xi === i ? u : x))) : onChange(images.filter((_, xi) => xi !== i))
          }
        />
      ))}
      <ImageUploader key="add" testid={`${testid}-add`} value={null} onChange={(u) => u && onChange([...images, u])} />
    </div>
  );
};
